module.exports = __webpack_public_path__ + "static/img/cont61_01.dd2cb9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont61_01.jpg
// module id = 0r6K
// module chunks = 0